import { useMemo } from "react";
import axios from "axios";
import { attachDeviceHeaders } from "./deviceTracking";

const useAPI = () => {
  const location = window.location;
  // Pages outside the claim link (e.g. /profile) have no ?t=; they always use the P2P API.
  const transferId = location.search.includes("?t=")
    ? location.search.split("?t=")[1].split("&i=")[0]
    : null;
  let baseUrl = process.env.REACT_APP_API_URL;
  // Only our main API records device activity. The disbursements API is a
  // separate service whose CORS config may not allow the extra headers.
  let isMainApi = true;

  if (transferId !== null && transferId.length !== 36) {
    baseUrl = process.env.REACT_APP_DISBURSEMENTS_API_URL;
    isMainApi = false;
  }

  const httpRequest = useMemo(() => {
    const instance = axios.create({
      baseURL: baseUrl,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (isMainApi) {
      attachDeviceHeaders(instance, "receiving-app");
    }
    return instance;
  }, [baseUrl, isMainApi]);

  let api = httpRequest;

  return api;
};

export default useAPI;
